export default {
  Codigo: null,
  Descripcion: '',
  CodigoAdicional: null,
  Activo: true,
};
